import React from 'react'
import { Paper } from '@mui/material';
import api from '../../API/api';


const ViewBlog = (props) => {


    const approveBlog = (id) => {
        api.approveBlog(id).then((res) => {
            // console.log(res);
            props.getBlogs();
            props.handleClose();
        })
            .catch((err) => {
                // console.log(err);
            })
    }

    return (
        <>
            <div className="col-md-12">
                <Paper elevation={3}>
                    <div className='row p-3'>
                        {props.blog &&
                            <>
                                <div>
                                    <div className='text-center'>
                                        <h3>{props.blog.title}</h3>
                                    </div>
                                    <img src={`${process.env.REACT_APP_BACKEND}blogs/cover/${props.blog.cover}`} alt={props.blog.title} className='col-12' />
                                </div>

                                <div className='m-3 p-3'>
                                    <div dangerouslySetInnerHTML={{ __html: props.blog.details }} />
                                </div>


                            </>
                        }


                    </div>
                </Paper>

            </div>
            {props.from !== 'approved' &&
                <div className='text-center m-3'>
                    <button className='btn btn-success' onClick={() => approveBlog(props.blog.id)}>Approve Blog</button>
                </div>
            }
        </>
    )
}

export default ViewBlog;